export default __webpack_public_path__ + "static/media/allattamento_b.ac8dd35a.png";